import { FC, useMemo } from "react";
import { CellProps, Column } from "react-table";
import { Center } from "@chakra-ui/react";
import { EditIcon } from "@chakra-ui/icons";
import { primaryColor } from "../../../utils/colors";
import TableComponent from "../../../components/organism/Table/TableComponent";
import { AuthUser } from "../../../types/User/AuthUser";

interface TableIndicatorAlertProps {
  setIdUpdateItem: (id: number) => void;
  dataTable: any[];
  isLoaded: boolean;
  user: AuthUser;
  setValue: (key: string, value: any) => void;
  openModal: (newTitle: string, newButtonTitle: string) => void;
}

const TableIndicatorAlert: FC<TableIndicatorAlertProps> = ({
  setIdUpdateItem,
  dataTable,
  isLoaded,
  user,
  setValue,
  openModal,
}) => {
  const columns = useMemo(() => {
    console.log(dataTable);
    const baseColumns: Column[] = [
      { Header: "Nome do Alerta SAN", accessor: "name" },
      { Header: "Frequência", accessor: "frequency.name" },
    ];

    if (user?.permissions && user.permissions.includes("EditAlertSan")) {
      baseColumns.push({
        Header: "Gerir",
        accessor: "edit",
        disableSortBy: true,
        Cell: ({ row }: CellProps<any, string>) => (
          <Center justifyContent="flex-end">
            <EditIcon
              color={primaryColor}
              boxSize={6}
              mr="10px"
              cursor="pointer"
              onClick={() => {
                openModal(`Editar Alerta SAN ${row.original.name}`, "Guardar");
                setIdUpdateItem(row.original.id);
                setValue("name", row.original.name);
                setValue(
                  "rationalDescription",
                  row.original.rationalDescription,
                );
                setValue("impactDescription", row.original.impactDescription);
                setValue("frequencyOption", row.original.frequency);

                if (
                  row.original.indicators &&
                  row.original.indicators.length > 0
                ) {
                  const initialIndicators = row.original.indicators.map(
                    (indicator: any) => ({
                      indicatorOptions: {
                        id: indicator.id,
                        name: indicator.name,
                      },
                    }),
                  );
                  setValue("indicators", initialIndicators);
                } else {
                  setValue("indicators", []);
                }
              }}
            />
          </Center>
        ),
      });
    }

    return baseColumns;
  }, [user.permissions, openModal, setIdUpdateItem, setValue]);

  return (
    <TableComponent
      isLoaded={isLoaded}
      columns={columns}
      data={dataTable}
      fixedColumnIds={[{ value: "edit", hasShadow: true }]}
    />
  );
};

export default TableIndicatorAlert;
